export default "__VITE_ASSET__fv$7slkJ__"